import { compose } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useChangeSort } from '@btime/react-contexts'
import { useTranslatedFormattedOptionsFromArray } from '../../../../../utils/hooks/select'
import SortSideModal from '../../../../../components/filter/SortSideModal'

const SORT_OPTIONS = ['NAME', 'PLACE_NAME', 'TYPE_NAME']

const AssetsSortModal = ({ open, onClose }) => {
  const { t } = useTranslation('listAsset')

  const sortOptions = useTranslatedFormattedOptionsFromArray(t, 'fields.', SORT_OPTIONS)
  const setSort = useChangeSort()
  const updateSortState = ({ field, type }) => setSort(field, type)
  const onSubmitSort = compose(onClose, updateSortState)

  return <SortSideModal open={open} onClose={onClose} fields={sortOptions} onSubmit={onSubmitSort} />
}

export default AssetsSortModal
